/*
* Copyright (C) Regione Lombardia
*/
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerAdapter } from '@shared/services/datepicker/datepicker-adapter.service';
import { DatepickerLanguages } from '@shared/services/datepicker/datepicker-languages.service';
import { DateParserFormatter } from '@shared/services/datepicker/datepicker-parser-formatter.service';

@Component({
    selector: 'app-toolkit-datepicker',
    templateUrl: './datepicker.component.html',
    providers: [
        { provide: NgbDateAdapter, useClass: DatepickerAdapter },
        { provide: NgbDateParserFormatter, useClass: DateParserFormatter },
        { provide: NgbDatepickerI18n, useClass: DatepickerLanguages },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SharedToolkitDatepickerComponent),
            multi: true,
        },
    ],
})
export class SharedToolkitDatepickerComponent implements ControlValueAccessor { // OnInit

    @Input() id: string = '';
    @Input() label: string = '';
    @Input() disabled: boolean = false;

    @Output() valueChanged = new EventEmitter();

    public dataStr: any;

    public onBlur() {
        this.valueChanged.emit(this.dataStr);
        this.onChange(this.dataStr);
        this.onTouched();
    }

    /* ControlValueAccessor */
    onChange: (_: any) => void = (_: any) => { };
    onTouched: () => void = () => { };
    writeValue(value: any) { this.dataStr = value; }
    registerOnChange(fn: any) { this.onChange = fn; }
    registerOnTouched(fn: any) { this.onTouched = fn; }

}
